import { render, staticRenderFns } from "./ContactsIndex.vue?vue&type=template&id=4a2dfbe2&scoped=true&lang=pug&"
import script from "./ContactsIndex.vue?vue&type=script&lang=js&"
export * from "./ContactsIndex.vue?vue&type=script&lang=js&"
import style0 from "./ContactsIndex.vue?vue&type=style&index=0&id=4a2dfbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2dfbe2",
  null
  
)

export default component.exports